module.exports = __webpack_public_path__ + "img/dialog.b512e2b2.png";